

import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionUnAuth, serviceCall } from '../../serviceCall'

export const getParticipantsApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunctionUnAuth( data,
        apiConstants.VIDEO.GET_PARTICIPANTS
    
 
    )
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
